import React, { useEffect, useState } from "react";
import AgencySideBar from "../Components/AgencySideBar";
import Navbar from "../../Components/Navbar";
import CalendarView from "./CalendarView";
import { useSelector } from "react-redux";
import {
  FetchAddAppoientmentVisit,
  FetchVisitReason,
  GetappointmentsbyPut,
  GetDeliveryMode,
  GetDoctorsRequest,
  GetPaymentSources,
  GetResource,
  Getserviceaddress,
  Updateappointmentstatus,
} from "../../../api/helper";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const Appointmentclinic = () => {
  const [view, setView] = useState("list");
  const [date, setDate] = useState(new Date());

  const handleDateChange = (date) => {
    setDate(date);
  };
  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <div className="dashboard-container">
      <AgencySideBar />
      <div className="dashboard-content">
        <Navbar />
        <div
          className="dashboard-cards"
          style={{ paddingLeft: 30, paddingRight: 30 }}
        >
          <div style={{ width: "100%" }}>
            <div className="tab-buttonstwo">
              <button
                className={`tab-buttontwo ${view === "list" ? "active" : ""}`}
                onClick={() => handleViewChange("list")}
              >
                Appointment List
              </button>
              <button
                className={`tab-buttontwo ${view === "calendar" ? "active" : ""
                  }`}
                onClick={() => handleViewChange("calendar")}
              >
                Calendar View
              </button>
            </div>
            <div style={{ width: "100%" }}>
              {view !== "list" ? <CalendarView /> : <AppointmentListView />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Appointmentclinic;

const AppointmentListView = () => {
  const [appointments, setAppointments] = useState([]);
  const [visitstatus, setvisitstatus] = useState([]);
  const profileData = useSelector((state) => state?.cookies?.userDetails);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedResource, setSelectedResource] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [providerdata, setproviderdata] = useState([]);
  const [resourcedata, setresourcedata] = useState([]);
  const [addressData, setaddressData] = useState([]);
  const [visitReasondata, setvisitReasondata] = useState([]);
  const [appointmentType, setappointmentType] = useState([]);
  const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
  const [paymentmethoddata, setpaymentmethoddata] = useState([]);
  const [selectedpayment, setselectedpayment] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigation = useNavigate();

  const GetAppoientmentVisit = async () => {
    const response = await FetchAddAppoientmentVisit(`?id=${profileData?._id}`);
    setvisitstatus(response?.data?.data);
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedProvider,
    selectedResource,
    selectedLocation,
    selectedReason,
    selectedStatus,
    selectedAppointmentType,
    selectedpayment,
  ]);

  const FetchAppointment = async (page = 1) => {
    const data = {
      agencyId: profileData?._id,
      page,
      limit: 5,
    };
    try {
      const respo = await GetappointmentsbyPut(data);
      setAppointments(respo?.data?.data?.appointments);
      setTotalPages(respo?.data?.data?.totalPages || 1);
    } catch (error) {
      console.log(error, "error---");
    }
  };
  const FetchDoctorrequest = async () => {
    try {
      const response = await GetDoctorsRequest({ status: "approved" });
      setproviderdata(response?.data.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchResource = async () => {
    try {
      const respo = await GetResource(profileData?._id);
      setresourcedata(respo?.data?.data?.results);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAddresslist = async () => {
    const data = {
      id: profileData?._id,
    };
    try {
      const response = await Getserviceaddress(data);
      setaddressData(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const GetVisitReason = async () => {
    const response = await FetchVisitReason(`?id=${profileData?._id}`);
    setvisitReasondata(response?.data?.data);
  };
  const FetchDatalist = async () => {
    try {
      const response = await GetDeliveryMode(`?id=${profileData?._id}`);
      setappointmentType(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchPaymentlist = async () => {
    try {
      const response = await GetPaymentSources(`?id=${profileData?._id}`);
      setpaymentmethoddata(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (profileData?._id) {
      FetchAppointment(currentPage);
    }
  }, [currentPage, profileData?._id]);

  useEffect(() => {
    FetchPaymentlist();
    FetchDatalist();
    GetVisitReason();
    FetchAddresslist();
    FetchResource();
    FetchDoctorrequest();
    GetAppoientmentVisit();
  }, []);

  const UpdateStatus = async (item, newStatus) => {
    const data = {
      appointmentStatus: newStatus,
    };
    try {
      const respo = await Updateappointmentstatus(data, item._id);
      FetchAppointment();
    } catch (error) {
      console.log(error);
    }
  };
  const filteredAppointments = appointments.filter((app) => {
    if (selectedProvider && app?.doctorRequestId?._id !== selectedProvider)
      return false;
    if (selectedResource && app?.appointmentResource !== selectedResource)
      return false;
    if (selectedLocation && app?.serviceLocationId?._id !== selectedLocation)
      return false;
    if (selectedReason && app?.visitReason?._id !== selectedReason)
      return false;
    if (selectedStatus && app?.appointmentStatus?._id !== selectedStatus)
      return false;
    if (selectedAppointmentType && app?.deliveryMode?._id !== selectedAppointmentType)
      return false;
    if (selectedpayment && app?.paymentSource !== selectedpayment)
      return false;

    if (startDate && endDate) {
      const appDate = new Date(app?.date).toISOString().split("T")[0];
      return appDate >= startDate && appDate <= endDate;
    }

    return true;
  });


  // console.log(appointments,"appointments=====")
  return (
    <div>
      <div
        className="calendar-filters_CalendarView"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Provider:</label>
          <select
            value={selectedProvider}
            onChange={(e) => setSelectedProvider(e.target.value)}
          >
            <option value="">-- Select Provider --</option>
            {providerdata.map((provider, index) => (
              <option key={provider._id} value={provider._id}>
                {provider.firstName} {provider.lastName}
              </option>
            ))}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Resource:</label>
          <select
            value={selectedResource}
            onChange={(e) => setSelectedResource(e.target.value)}
          >
            <option value="">-- Select Resource --</option>
            {resourcedata.map((item) => {
              return (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Location:</label>
          <select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="">-- Select Location --</option>
            {addressData.map((item) => {
              return (
                <option key={item._id} value={item?._id}>
                  {item?.name}
                </option>
              );
            })}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Reason:</label>
          <select
            value={selectedReason}
            onChange={(e) => setSelectedReason(e.target.value)}
          >
            <option value="">-- Select Reason --</option>
            {visitReasondata.map((item) => {
              return (
                <option key={item._id} value={item._id}>
                  {item.visitReason}
                </option>
              );
            })}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Status:</label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">-- Select Status --</option>
            {visitstatus.map((item) => {
              return (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Appointment Type:</label>
          <select
            value={selectedAppointmentType}
            onChange={(e) => setSelectedAppointmentType(e.target.value)}
          >
            <option value="">-- Select type--</option>
            {appointmentType.map((item, index) => (
              <option key={item._id} value={item._id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Payment Method:</label>
          <select
            value={selectedpayment}
            onChange={(e) => setselectedpayment(e.target.value)}
          >
            <option value="">-- Select type--</option>
            {paymentmethoddata.map((item, index) => (
              <option key={item._id} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>Start Date:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div
          className="form-group_CalendarView"
          style={{
            flex: "1 1 calc(20% - 16px)",
            minWidth: "200px",
          }}
        >
          <label>End Date:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

      </div>
      <h2 style={{ textAlign: "left" }}>List View of Appointments</h2>
      <div className="appointments-table-container_CalendarView">
        <table className="appointments-table_CalendarView">
          <thead>
            <tr>
              <th>SessionID</th>
              <th>Client</th>
              <th>Provider</th>
              <th>Type</th>
              <th>Payment Method</th>
              <th>Duration</th>
              <th>Billing Unit</th>
              <th>SubTotal</th>
              <th>Visit Reason</th>
              <th>Date</th>
              <th>Location</th>
              <th>PA Number</th>
              <th>Ref. NPI</th>
              <th>Status</th>
              <th>Create Note</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAppointments.length === 0 ? (
              <tr>
                <td
                  colSpan="16"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No matching appointments found.
                </td>
              </tr>
            ) : (
              filteredAppointments.map((app) => (
                <tr key={app?._id}>
                  <td>{app?._id?.slice(-7)}</td>
                  <td>
                    <div
                      onClick={() =>
                        navigation("/ClientEditbyagency", {
                          state: { data: app?.patientRequestId },
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {app?.patientRequestId?.firstName}{" "}
                      {app?.patientRequestId?.lastName}
                    </div>
                  </td>
                  <td>
                    <div
                      onClick={() =>
                        navigation("/DoctorDetailsclinic", {
                          state: { data: app?.doctorRequestId },
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {app?.doctorRequestId?.firstName}{" "}
                      {app?.doctorRequestId?.lastName}
                    </div>
                  </td>
                  <td>{app?.deliveryMode?.name}</td>
                  <td>{app?.paymentSource}</td>
                  <td>{app?.Duration}</td>
                  <td>{"2"}</td>
                  <td>{"$150.00"}</td>
                  <td>{app?.visitReason?.visitReason}</td>
                  <td>
                    {app?.date ? moment(app.date).format("DD/MM/YYYY") : ""}
                  </td>
                  <td>{app?.serviceLocationId?.name}</td>
                  <td>
                    {app?.authorizationDetailId?.Auth
                      ? app.authorizationDetailId.Auth
                      : "Not Available"}
                  </td>
                  <td>{"999999999"}</td>

                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        <span
                          className="status-badge_two"
                          style={{
                            background: app?.appointmentStatus?.color,
                            color: "white",
                          }}
                        >
                          {app?.appointmentStatus?.name || "Pending"}
                        </span>
                        <i className="fas fa-ellipsis-v" />
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          {visitstatus
                            .filter(
                              (statusObj) =>
                                statusObj.name.trim().toLowerCase() !==
                                (app?.appointmentStatus?.name || "")
                                  .trim()
                                  .toLowerCase()
                            )
                            .map((statusObj) => (
                              <li key={statusObj._id}>
                                <button
                                  className="custom-dropdown-item"
                                  onClick={() =>
                                    UpdateStatus(app, statusObj?._id)
                                  }
                                >
                                  {statusObj.name}
                                </button>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </td>

                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        Create Note ⋮
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          <li>
                            <button className="custom-dropdown-item">
                              Clinical Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Therapeutic Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Operational Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Observation Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              General Note
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>

                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        Actions ⋮
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          <li>
                            <button className="custom-dropdown-item">
                              Edit Appointment
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Cancel Appt
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Send Reminder
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              View Full Details
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Capture Charges
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Create Invoice
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Join Telehealth
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="pagination-controls_CalendarView">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{ color: "black" }}
          >
            Previous
          </button>

          <span style={{ margin: "0 10px", marginTop: 10 }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="active"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
